export class InternalCustomerDetailModelList {

    constructor(){
        this.data = new Array<any>();
        

    }

    data: Array<any>;
}
export class AplicantDetailModel {
    area: string;  
    canal: string;  
    fecha_aplicacion: Date;
    pcn: string;  
    dni: string;  
    nombre: string;  
    domicilio: string;  
    localidad: string;  
    celular: string;  
    telefono: string;  
    estado: string; 
    subestado: string; 
    motivo: string; 
    promotor: string;
    promotor_original: string; 
    prod: string; 
    observacion: string;
    fechaModificacion : string;
    cuil:string;
    estadoRegistro: string;

}


export class BusquedaFiltrosModel {

    pcn: string;
    dni: string;
    nombre: string;
    cuil: string;
}

export class InternalCustomerDetailModel{
    apellido: string;
    area: string;
    cuil: string;
    denegado: boolean;
    docNum: string;
    nacionalidad: string;
    nombre1: string;
    nombre2: string;
    nombreCompleto: string;
    pcn: string;
    estado: string;
    intPersonaSuples: IntPersonaSuples[];
    internalSourceCode: InternalSourceCode;
    fechaModificacion: string;
    accion: string;
    fechaAprobado:string;
    fechaArchivo: string;
    canalArchivo: string;
    intSocioData: intSocioData;
    tipoVenta: string;
    motivo: string;
    intObservaciones: IntObservaciones[];
    lastObservation: string;
    estadoRegistro: string;
    keyDigits: string;
    informedPromotor: string;
    productoObj: ProductoObj;
    productoSocioObj: ProductoObj;
    informedProduct: string;
    baseProduct: ProductoObj;
}
export class ProductoObj{
    key : string;
    value : string;
    data: dataProduct
  }
export class dataProduct{
    id : string;
    income : string;
    prod : string;
    prodLgf : string;
    prodMgm : string;
    prodName : string;
  }

export class IntPersonaSuples{
    genero: string;
    vinculo: string;
    nombre1: string;
    nombre2: string;
    apellido: string;
    activo: string;
    fnac: string;
    nombreCompleto: string;
    nombreCompletoNosis: string;
    nosisFnac: string;
    plasticColorType: string;
    tipoDoc: string;
    bridgerStatus: string;
    caseNumber: string;
    docNumSuple: string;
    lastUpdate: string;
    usuarioIc: string;
    caseStatus: string;
    pcnSuple: string;
    insertDate: string;
    index: number;
    estado: string;
    accion: string;
    motivo: string;
    estadoRegistro: string;
    denegado: string;
    area: string;
    prod: string;
    prodName: string;
    idProd: string;
}

export class InternalSourceCode{
    idPromotor: string;
    comercializadora: string;
    nombreProducto: string;
    prod: string;
    sourceCodeCompleto: string;
}

export class intSocioData{
    
    cuil: string;
    firstName: string;
    secondName: string;
    lastName: string;
    cardName: string;
    birthDate: string;
    dniType: string;
    dni: string;
    gender: string;
    tel1: string;
    tel2: string;
    email: string;
    postalCode: string;
    province: string;
    city: string;
    street: string;
    civilState: string;
    ivaType: string;
    profession: string;
    company: string;
    ocupation: string;
    area: string;
    monthlySalary: string;
    mr: string;
    memberSinceTitular: string;
    loc: string;
    income: string;
    nationality: string;
    keyDigits: string;
    producto: string;

}

export class IntObservaciones{
    area: string;
    fecha: string;
    id: string;
    observacion: string;
    persona:string;
  }